import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'

import useLegalAgreements from '../../../../hooks/useLegalAgreements'
import { displayNameForAgreementId } from '../../../../utils/legalAgreements'
import ReviewPendingAgreement from '../../../global/agreements/ReviewPendingAgreement'
import ClickWrapContextProvider from '../../../global/clickwrap/ClickWrapContextProvider'
import ClickWrapModal from '../../../global/clickwrap/ClickWrapModal'
import { ClickWrapModalContext } from '../../../global/clickwrap/context'
import HeaderWithSecondaryButton from '../HeaderWithSecondaryButton'

export interface PendingAgreementsProps {
  className?: string
}

const PendingAgreements: React.FC<PendingAgreementsProps> = ({ className }) => {
  const { pending } = useLegalAgreements()
  const [, modalDispatch] = useContext(ClickWrapModalContext)
  const openClickWrap = () => {
    modalDispatch({ type: 'open' })
  }

  useEffect(() => {
    if (!pending.length) {
      modalDispatch({ type: 'close' })
    }
  }, [modalDispatch, pending.length])

  return (
    <section className={className}>
      {pending.length > 0 && (
        <>
          <HeaderWithSecondaryButton
            headerText="Pending Agreements"
            className="section-header"
            buttonText="Accept Pending"
            onClick={openClickWrap}
          />
          <div className="section-body">
            <ul>
              {pending.map((agreementId) => (
                <li key={agreementId}>{displayNameForAgreementId(agreementId)}</li>
              ))}
            </ul>
          </div>
        </>
      )}
      <ClickWrapModal>
        <ClickWrapContextProvider accepted={false}>
          {pending.length > 0 && <ReviewPendingAgreement agreementId={pending[0]} />}
        </ClickWrapContextProvider>
      </ClickWrapModal>
    </section>
  )
}

const StyledPendingAgreements = styled(PendingAgreements)(({ theme }) => ({
  marginBottom: '17px',
  '.section-header': {
    marginBottom: '1em',
  },
  '.section-body': {
    backgroundColor: theme.colors.grayscale.white,
    borderRadius: '4px',
    padding: '24px',
    lineHeight: '1.5',
  },
  ul: {
    paddingInlineStart: '20px',
  },
  li: {
    listStyle: 'disc',
  },
}))

export default StyledPendingAgreements
